import 'pixi';
import 'p2';
import Phaser from 'phaser';

import BootState from './states/Boot';
import GameState from './states/Game';

import config from './config';
import { effects, rng, sample } from './effects';

class Game extends Phaser.Game {
  constructor() {
    const docElement = document.documentElement;
    const width = config.gameWidth;
    const height = config.gameHeight;

    super(width, height, Phaser.CANVAS, 'content', null);

    const net = new Phaser.Net(this);

    if (JSON.stringify(net.getQueryString('effect')) === '{}') {
      this.effectName = 'random';
    } else {
      this.effectName = net.getQueryString('effect');
    }

    this.effect = setEffect(this.effectName);
    this.state.add('Boot', BootState, false);
    this.state.add('Game', GameState, false);
    this.state.start('Boot');
  }
}
function setEffect(effectName) {
  if (effectName === 'random') {
    effectName = sample(['splatter', 'squish', 'bump', 'drift', 'shift', 'spin', 'springy', 'crunch', 'fadeLeft', 'fadeRight', 'slantLeft', 'slantRight', 'splitX', 'splitY', 'cross', 'crossPass', 'splitRL', 'blob', 'bullet']);
    document.getElementById('effect-name').innerHTML = effectName;
    document.getElementById('random-label').style.display = 'inline';
  } else {
    document.getElementById('effect-selector').value = effectName;
    document.getElementById('random-label').style.display = 'none';
  }

  return effects[effectName];
}

function changeEffect(e) {
  e.preventDefault();
  const sel = e.target;
  const effectName = sel.options[sel.selectedIndex].value;
  window.game.effectName = effectName;
  window.game.effect = setEffect(effectName);
  window.game.state.restart();
}

function changePage(e, dir) {
  e.preventDefault();
  let page = parseInt(document.getElementById('page-num').value);
  if (dir === 'next') {
    page += 1;
  } else {
    page -= 1;
  }
  page = Math.max(page, 1);

  setPageTo(page);

  window.game.effect = setEffect(window.game.effectName);
  window.game.state.restart();
}
function setPageTo(page) {

  const book = window.game.cache.getJSON('book');
  if (book.length - 1 >= page) {
    const chapter = book[page];
    const text = chapter.join('\n');
    document.getElementById('text').innerHTML = text;
    document.getElementById('page-num').value = page;
  }
}

function changePageNum(e) {
  e.preventDefault();
  let page = parseInt(document.getElementById('page-num').value);
  setPageTo(page);
  window.game.effect = setEffect(window.game.effectName);
  window.game.state.restart();
}

function changeContent(e) {
  e.preventDefault();
  const text = document.getElementById('custom-content').innerHTML;
  document.getElementById('text').innerHTML = text;
  window.game.effect = setEffect(window.game.effectName);
  window.game.state.restart();
}

window.game = new Game();
window.changeEffect = changeEffect;
window.changePage = changePage;
window.changePageNum = changePageNum;
window.changeContent = changeContent;


//////////////////
// WEBPACK FOOTER
// ./src/main.js
// module id = 332
// module chunks = 0